import React from 'react';
import { ICommanderOfflinePanel } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import CommanderOfflineWorkspacePanel from './CommanderOfflineWorkspacePanel';
import { LayoutItem } from 'react-grid-layout';
import CommanderOfflineGroupPanel from './CommanderOfflineGroupPanel';
import CommanderOfflineUserPanel from './CommanderOfflineUserPanel';
import CommanderOfflineWorkspacesPanel from './CommanderOfflineWorkspacesPanel';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface CommanderOfflinePanelProps {
  panel: ICommanderOfflinePanel;
  layout?: LayoutItem | undefined;
}
function CommanderOfflinePanel(props: CommanderOfflinePanelProps) {
  const { panel, layout } = props;
  const { typeRequest } = panel;
  const { t } = useTranslation();
  switch (typeRequest) {
    case 'workspace':
      return <CommanderOfflineWorkspacePanel panel={panel} layout={layout} />;
    case 'group':
      return <CommanderOfflineGroupPanel panel={panel} layout={layout} />;
    case 'user':
      return <CommanderOfflineUserPanel panel={panel} layout={layout} />;
    case 'workspaces':
      return <CommanderOfflineWorkspacesPanel panel={panel} layout={layout} />;
    default:
      console.error(`Unknown typeRequest: ${typeRequest}`);
      return (
        <Alert severity="error">
          {t('dashboard.error.unsupported_panel_type')}
        </Alert>
      );
  }
}

export default CommanderOfflinePanel;
